import React from 'react';
import logo from '../../../../../assets/Logo/logo.png';
import './HeaderLogo.scss';

export const HeaderLogo = () => {
  return <img className="HeaderLogo" src={logo} alt="Get U There Logo" />;
};
